import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as UtilizationActions from './utilization.action';
import * as SpecificationActions from '../specification/specification.action';
import { UtilizationService } from './utilization.service';
import { BannerService } from '../../shared/services/banner.service';
import * as UtilizationModels from '../../models/utilization/utilization';
import { UtilizationSearchModel } from '../../models/utilization/utilizationSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { SaveState } from '../../models/commonModels';
import { HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';


export interface UtilizationStateModel {
    List: UtilizationModels.UtilizationListModel;
    Search: UtilizationSearchModel;
    Save: SaveState;
    FilteredReportLoading: boolean;
  }

@State<UtilizationStateModel>({
    name: 'utilizationState',
    defaults: {
      List: null,
      Search: null,
      Save: null,
      FilteredReportLoading: false,
    }
  })

  @Injectable()

  export class UtilizationState {

    constructor(
      private helperService: HelperService,
      private utilizationService: UtilizationService,
      private bannerService: BannerService
  ) { }

  @Selector()
  static List(state: UtilizationStateModel) {
    return state.List;
  }

  @Selector()
  static Save(state: UtilizationStateModel) {
    return state.Save;
  }

  @Selector()
  static UtilizationSearch(state: UtilizationStateModel) {
    return state.Search;
  }

  @Selector()
  static FilteredReportLoading(state: UtilizationStateModel) {
    return state.FilteredReportLoading;
  }

  @Action(UtilizationActions.GetList)
  getList(
    context: StateContext<UtilizationStateModel>,
    action: UtilizationActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy utylizacji.';

    context.setState(
      patch({
        List: null
      })
    );

    this.utilizationService.get(action.Search).subscribe((ret) => {

      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('UtilizationActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(UtilizationActions.SetSearch)
  setSearch(
    context: StateContext<UtilizationStateModel>,
    action: UtilizationActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;
    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new UtilizationActions.GetList(action.Search));
  }

  @Action(UtilizationActions.SetListPage)
  setListPage(
    context: StateContext<UtilizationStateModel>,
    action: UtilizationActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new UtilizationActions.GetList(action.Search));
  }

  @Action(UtilizationActions.ResetSearch)
  resetSearch(
    context: StateContext<UtilizationStateModel>
  ) {

    const state = context.getState();

    const search = new UtilizationSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new UtilizationActions.GetList(search));
  }


  @Action(UtilizationActions.GetFilteredReport)
  getFilteredReport(
      context: StateContext<UtilizationStateModel>,
      action: UtilizationActions.GetFilteredReport
   ) {
        function patchContext( loading: boolean) {
          context.setState(
            patch ({
                FilteredReportLoading: loading
            })
          );
        }

        patchContext(true);
        const fileName = 'Utylizacje';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.utilizationService.getReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext(false);
              },
              res => {
                patchContext(false);
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext(false);
                this.helperService.consoleLog('UtilizationActions.GetFilteredReport');
              }
          );
}


@Action(UtilizationActions.DisposeSearch)
disposeSearch(
    context: StateContext<UtilizationStateModel>
  ) {

    context.setState(
      patch({
        Search: null
      }));
}

}


